import { ContactIcon } from "@fluentui/react-icons-mdl2";

import { InvoiceAccount } from "../../interfaces/invoices-response";

import {
  Card,
  Content,
  Field,
  FieldLabel,
  FieldValue,
  Header,
  StatusBadge,
  Title,
  Column
} from "./style";

export default function AccountInfo({
  name,
  document,
  isAssociated,
  contractChannel,
  contractNumber
}: InvoiceAccount) {
  return (
    <Card>
      <Header>
        <Title>
          <ContactIcon />
          Informações do Cooperado
        </Title>
      </Header>

      <Content>
        <Column>
          <Field>
            <FieldLabel>Nome</FieldLabel>
            <FieldValue>{name}</FieldValue>
          </Field>
          <Field>
            <FieldLabel>Parceiro</FieldLabel>
            <FieldValue>{contractChannel}</FieldValue>
          </Field>
          <Field>
            <FieldLabel>Status de Associação</FieldLabel>
            <StatusBadge status={isAssociated}>{isAssociated}</StatusBadge>
          </Field>
        </Column>
        <Column>
          <Field>
            <FieldLabel>CPF</FieldLabel>
            <FieldValue>{document}</FieldValue>
          </Field>
          <Field>
            <FieldLabel>Número do Contrato</FieldLabel>
            <FieldValue>{contractNumber}</FieldValue>
          </Field>
        </Column>
      </Content>
    </Card>
  );
}
